import { fetchProfileForRouteGuard } from '~~/layers/base/composables/fetchProfileForRouteGuard'
import { denyStaffAdminRoute } from '~~/layers/crane-manager/utils/denyStaffAdminRoute'

/**
 * Named route middleware: only the Crane panel admin tier may enter the route (`isAdmin` from
 * `GET /api/profile`: Crane role `super` / `admin`, or legacy `is_admin` without a role).
 *
 * Anonymous sessions and non-admin accounts are redirected to `/crane-manager/login`.
 *
 * Usage on a page:
 * `definePageMeta({ middleware: 'is-admin' })`
 */
export default defineNuxtRouteMiddleware(async (to) => {
    const profile = await fetchProfileForRouteGuard()
    if (!profile) {
        return denyStaffAdminRoute(to, 'unauthenticated')
    }
    if (!profile.isAdmin) {
        return denyStaffAdminRoute(to, 'forbidden')
    }
})
